/**
 * @returns {Promise<unknown>}
 */
import { yaTag } from './yandex.tag';

export const onYaTag = () => {
  const yaID = 7831675;
  const classNames = {
    click: '[data-ya-click]',
    select: '[data-ya-select]',
  };

  $(classNames.select).on('select2:select', (e) => {
    const { element } = e.params.data;
    const optionKey = element.dataset.yaOption.toUpperCase();
    const tag = element.parentElement.dataset.yaSelect.replace('$option', optionKey);
    (async function () {
      await yaTag(tag);
    }());
  });

  return new Promise(((resolve, reject) => {
    const elements = document.querySelectorAll(classNames.click);
    [...elements].forEach((el) => {
      el.addEventListener('click', function () {
        // const params = this.dataset.yaParams || null;
        const target = document.querySelector(this.dataset.target);
        const clickTagName = getReplacedYaTagName(this);

        if (this.dataset.toggle === 'modal' && target !== null) {
          target.dataset.parent = this.dataset.parent;
        }

        if (this) {
          // console.log(`%c [YANDEX_TAG] ${clickTagName} || ${params}`, 'color: yellow;');
          // eslint-disable-next-line
          ym(yaID, 'reachGoal', clickTagName);
          resolve(this);
        } else {
          console.log(`%c NOT FOUND${clickTagName}`, 'color: red;');
          reject();
        }
      });
    });
  }));
};

export const getReplacedYaTagName = (tag) => {
  const page = document.body.className.split(' ')[0] || '';
  let parent = tag.closest('[data-parent]')?.dataset.parent || '';

  if (parent === 'undefined') parent = '';
  return tag.dataset.yaClick
    .replace('$prefix_', `${page.toUpperCase()}_`)
    .replace('$parent_', `${parent.toUpperCase()}_`);
};

window.onYandexTag = onYaTag;
